import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmbarcadorAutonomousGuard  {

  constructor(
    private _userService: UserService,
    private _router: Router
  ){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<any> | Promise<any> | boolean | UrlTree | any
    {
      const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
      this._userService.recoveryUserSession();
      return this._userService.user$
      .pipe(
        switchMap((res: any) => {
          if (res) {
            const userType = res.client != undefined? res.client.type : res.company.clientType;
            if (['EMBARCADOR','FACTORY','INDUSTRY','JODAX','SHIPPER'].includes(userType)) {
              const rolePermission = res.role_id || res.roles;
              if (typeof rolePermission === 'object') {
                return (rolePermission.includes('premix_rastreabilidade_access'))? of(true) : of(false);
              } else {
                if (rolePermission !== 22) {
                  this._router.navigate(['dashboard']);
                  return of(false);
                }
                return of(true);
              }
            } else {
              return of(false);
            }
          } else {
            this._router.navigate(['sign-in'], {queryParams: {redirectUrl}});
          }
        })
      );
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
}
